module.exports = __webpack_public_path__ + "static/img/1.ceb1764.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/1.png
// module id = RGif
// module chunks = 0